import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Xaintro';

  constructor(private router: Router) { }

  openChat() {
    // Navigate to chat route
    this.router.navigate(['/chat']);
  }
}
